import React from 'react'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
import { useApiFormAsset } from '../../../../../api-new/state/content'
import { useApiListAsset } from '../../../../../api-new/state/content'
import { Route, useRouteMatch } from 'react-router-dom'

import { Purge } from '../../../../../shared/page/page-purge'
import { IconRecycle } from '../../../../../shared/icon/icon'
import { ColumnMenu, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export const AssetRecycle = () => {
  const { url } = useRouteMatch()

  const apiListAsset = useApiListAsset()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAsset.get('deleted')
  const handleDestroyed = () => apiListAsset.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAsset.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That asset was already removed.'), err)
    }
    await apiListAsset.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconRecycle} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAsset} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/${row.id}/purge`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/:purgeID/purge`}>
        <Purge useApiForm={useApiFormAsset} titleParam="name" successPath={`${url}`} />
      </Route>
    </React.Fragment>
  )
}
